<template>
  <b-card>
    <div class="d-flex justify-content-between flex-wrap my-1">
      <h4>{{ $t('backoffice.settings.subtitle-emails') }}</h4>
      <div class="d-flex">
        <b-button variant="primary" @click="addEmailCouple()">
          <feather-icon
            icon="PlusCircleIcon"
            class="text-white"
          />
        </b-button>
        <b-button variant="primary" class="ml-1" @click="saveEmails()">
          {{ $t('form.actions.save') }}
        </b-button>
      </div>
    </div>
    <div v-if="$route.name === 'globalMemberSettings'">
      <label for="main" class="font-weight-bold"> {{ $t("backoffice.settings.main-email") }}</label>
      <b-form-input
        id="email-name"
        v-model="mainEmail"
        type="text"
        readonly
        class="mb-2"
        :placeholder="$t('form.type-placeholder')"
      />
    </div>
    <div v-if="isFirstEmailSectionVisible" class="d-flex flex-wrap">
      <!-- Name -->
      <b-form-group class="flex-grow-1">
        <label for="email-name" class="font-weight-bold"> {{ $t("backoffice.settings.name") }}</label>
        <b-form-input
          id="email-name"
          v-model="currentEmail.label"
          type="text"
          :placeholder="$t('form.type-placeholder')"
        />
      </b-form-group>
      <!-- Email -->
      <b-form-group class="ml-sm-1 flex-grow-1">
        <label for="email-name" class="font-weight-bold"> {{ $t("backoffice.settings.email-label") }}</label>
        <div class="d-flex align-items-center">
          <b-form-input
            id="email-name"
            v-model="currentEmail.email"
            type="email"
            :state="isValid"
            @input="validator(currentEmail.email)"
            :placeholder="$t('form.type-placeholder')"
          />
          <feather-icon 
            v-if="currentEmail.email" 
            icon="Trash2Icon" 
            size="16" 
            class="ml-50 text-primary pointer" 
            @click="clearCurrentEmail"
          />
        </div>
      </b-form-group>
    </div>
    <!-- All emails -->
    <div v-for="(email, index) in emailsList" :key="index" class="d-flex flex-wrap">
      <!-- Name -->
      <b-form-group class="flex-grow-1">
        <label for="email-name" class="font-weight-bold"> {{ $t("backoffice.settings.name") }}</label>
        <b-form-input
          id="email-name"
          v-model="emailsList[index].label"
          type="text"
          :placeholder="$t('form.type-placeholder')"
        />
      </b-form-group>
      <!-- Email -->
      <b-form-group class="ml-sm-1 flex-grow-1">
        <label for="email-name" class="font-weight-bold"> {{ $t("backoffice.settings.email-label") }}</label>
        <div class="d-flex align-items-center">
          <b-form-input
            id="email-name"
            v-model="emailsList[index].email"
            type="email"
            @input="validator(emailsList[index].email)"
            :placeholder="$t('form.type-placeholder')"
          />
          <feather-icon icon="Trash2Icon" size="16" class="ml-50 text-primary pointer" @click="removeItem(index)"/>
        </div>
      </b-form-group>
    </div>
  </b-card>
</template>

<script>
import ToastNotificationsMixin from '@core/mixins/toast-notifications/ToastNotificationsMixin';
import { validatorEmailValidator } from '@/@core/utils/validations/validators';

export default {
  name: 'Emails',
  mixins: [ToastNotificationsMixin],
  props: {
    emails: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentEmail: {
        label: null,
        email: null,
      },
      emailsList: this.emails,
      isValid: null,
      isFirstEmailSectionVisible: false,
      isRemoving: false,
    };
  },
  computed: {
    currentCollective() {
      return this.$store.getters.currentCollective;
    },
    isSaveEnabled() {
      return this.form.name && this.form.slug && (this.form.accessibilityAux || this.form.accessibility) && (this.form.visibilityAux || this.form.visibility);
    },
    isSubcommunity() {
      return this.currentCollective.parentKey != null;
    },
    isDisabled() {
      return !this.form.name || !this.form.slug || !this.form.visibility || !this.form.accessibility;
    },
    locale() {
      return this.$store.state.locale.currentLocale;
    },
    mainEmail() {
      return this.loggedMember != null && this.loggedMember.email != null ? this.loggedMember.email : this.loggedUser.email 
    },
    loggedMember() {
      return this.$store.getters.loggedMember;
    },
    loggedUser() {
      return this.$store.getters.loggedUser;
    },
  },
  watch: {
    emails(value) {
  
      return value;
    },
  },
  created() {
    setTimeout(this.initialStatus, 1000);
  },
  methods: {
    initialStatus() {
      if (this.emailsList.length > 0) {
        this.isFirstEmailSectionVisible = false;
      } else {
        this.isFirstEmailSectionVisible = true;
      }
    },
    addEmailCouple() {
      if (this.currentEmail.email && this.currentEmail.email !== null && validatorEmailValidator(this.currentEmail.email)) {
        this.emailsList.push(this.currentEmail);
        this.currentEmail = {};
        this.isValid = null;
      } else if (this.isRemoving) {
        this.isValid = null;
      } else {
        this.isValid = false;
      }
      this.isFirstEmailSectionVisible = true;
    },
    clearCurrentEmail() {
      this.currentEmail = {
        label: null,
        email: null,
      };
      this.isValid = null;
    },
    async saveEmails() {
      this.addEmailCouple();
      this.emailsList = this.emailsList.filter(({ email }) => email !== '');
      this.emailsList.length > 0 ? this.isFirstEmailSectionVisible = false : true;
      this.currentEmail = {};
      const address = this.emailsList.map(({ email, label }) => ({ email, label }));
      if (address.length > 0 || this.isRemoving) {
        this.$emit('save-mails', address);
        // try {
        //   await this.$store.dispatch('addSettings', { emails: address });
        //   this.notifySuccess(this.$t('backoffice.settings.messages.success'));
        // } catch {
        //   this.notifyError(this.$t('backoffice.settings.messages.error'));
        // }
      } else {
        this.notifyError(this.$t('backoffice.settings.messages.error'));
      }
      this.isRemoving = false;
    },
    validator(item) {
      this.isValid = validatorEmailValidator(item);
    },
    removeItem(index) {
      this.emailsList.splice(index, 1);
      this.isRemoving = true;
      if (this.emailsList.length <= 0) {
        this.addEmailCouple();
      }
    },
  },
};
</script>
